import React from "react";
import { FaRegCalendarCheck, FaMapMarkerAlt } from "react-icons/fa";

export default function Location(props) {
  return (
    <section className="times">
      <div className="font18">{props.place}</div>
      <div className="font18 mt5">{props.city}</div>
      <div className="mt10 font36">
        <a
          className={`${props.textColor} textWhite`}
          href={props.location}
          target="_blank"
          rel="noreferrer"
        >
          <FaMapMarkerAlt />
        </a>
      </div>
      <div className="locationLinkContainer">
        <a
          className={`locationLink LatoRegular textWhite ${props.textColor} ${props.borderColor}`}
          href={props.location}
          target="_blank"
          rel="noreferrer"
        >
          Location Map
        </a>
      </div>
    </section>
  );
}
